// @flow

import moment from 'moment-timezone'

/**
 * Static functions list
 */
class Utils {
    /**
     * Check if a NIR OR INS is valid.
     * @param {string} val = value to check
     */
    static checkNirOrInsIsValid(val: string) {
        if (val.length !== 15 && val.length !== 16)
            // 15 is for real ins, 16 is for demot or test nir with suffix T or D
            return false
        return true
    }

    /**
     * Checks if a birthDate is in good format eg -> YYYYMMDD
     * @param {string} val = value to check
     */
    static checkBirthDate(val: string) {
        if (moment(val, 'YYYYMMDD', true).isValid()) return true
        return false
    }

    /**
     * Format a date from YYYYMMDD to YYMMDD
     * @param {string} val = value to format
     */
    static formatBirthDateFromEightToSix(val: string) {
        return moment(val, 'YYYYMMDD').format('YYMMDD')
    }

    /**
     * Format a date to YYYY-MM-DD
     * @param {string} val = iso to format
     */
    static formatBirthDateToTen(val: string) {
        return moment(val).format('YYYY-MM-DD')
    }

    /**
     * return the age from a date
     * @param {string} val = iso to format
     */
    static getAge(val: string) {
        return moment().diff(moment(val), 'years')
    }
}

export default Utils
